const AUTHOR_PRESETS = [
  {
    id: 'yuzuki-tsukihana',
    label: 'Yuzuki Tsukihana · Japan With Love',
    formData: {
      authorName: 'Yuzuki Tsukihana',
      authorImageUrl:
        'https://cdn.shopify.com/s/files/1/0512/5429/6766/files/author-yuzuki-tsukihana-2_400x.png',
      authorDescription:
        'Yuzuki Tsukihana is a Japanese beauty writer and researcher with over 8 years of experience in the skincare and cosmetics industry. She holds a Master of Science in Cosmetic Science from the University of Cincinnati (USA), where she specialized in skincare formulation, ingredient efficacy, and product safety.',
      authorTagUrl: 'https://japanwithlovestore.com/blogs/blogs/tagged/author-yuzuki-tsukihana',
    },
  },
  {
    id: 'minase-suiren',
    label: 'Minase Suiren · Japan With Love',
    formData: {
      authorName: 'Minase Suiren',
      authorImageUrl:
        'https://cdn.shopify.com/s/files/1/0512/5429/6766/files/author-minase-suiren-2_400x.png',
      authorDescription:
        'Minase Suiren is a seasoned cultural writer and lifestyle curator focusing on Japanese beauty rituals and everyday aesthetics. She holds a master’s degree in intercultural communication from Waseda University with a research focus on beauty norms and gender identity in modern Japanese media.',
      authorTagUrl: 'https://japanwithlovestore.com/blogs/blogs/tagged/author-minase-suiren',
    },
  },
  {
    id: 'rikuya-takamine',
    label: 'Rikuya Takamine · Japan Figure',
    formData: {
      authorName: 'Rikuya Takamine',
      authorImageUrl:
        'https://cdn.shopify.com/s/files/1/0568/2298/8958/files/Author-rikuya-takamine.jpg',
      authorDescription:
        'Rikuya Takamine has been writing about Japanese pop culture for over seven years. With a background in media and communications, he covers major TCG releases and collectible figure launches with accuracy and excitement for leading Japanese pop culture platforms.',
      authorTagUrl: 'https://japan-figure.com/blogs/news/tagged/author-rikuya-takamine',
    },
  },
  {
    id: 'soma-higarashi',
    label: 'Soma Higarashi · Japan Figure',
    formData: {
      authorName: 'Soma Higarashi',
      authorImageUrl:
        'https://cdn.shopify.com/s/files/1/0568/2298/8958/files/Author-soma-higarashi.jpg',
      authorDescription:
        'Soma Higarashi has over five years of experience covering anime, manga, and Japanese pop culture. He is also an active community leader who moderates several large fan groups dedicated to anime and Japanese culture, sharing insights with audiences worldwide.',
      authorTagUrl: 'https://japan-figure.com/blogs/news/tagged/author-soma-higarashi',
    },
  },
];

export default AUTHOR_PRESETS;

